var _rect, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionDCrossOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#272727",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 20.5H17.0114V8.86364H21.1705C22.3409 8.86364 23.3485 9.09659 24.1932 9.5625C25.0379 10.0246 25.6875 10.6894 26.142 11.5568C26.6004 12.4242 26.8295 13.4621 26.8295 14.6705C26.8295 15.8826 26.6004 16.9242 26.142 17.7955C25.6875 18.6667 25.0341 19.3352 24.1818 19.8011C23.3333 20.267 22.3182 20.5 21.1364 20.5ZM19.4716 18.392H21.0341C21.7614 18.392 22.3731 18.2633 22.8693 18.0057C23.3693 17.7443 23.7443 17.3409 23.9943 16.7955C24.2481 16.2462 24.375 15.5379 24.375 14.6705C24.375 13.8106 24.2481 13.108 23.9943 12.5625C23.7443 12.017 23.3712 11.6155 22.875 11.358C22.3788 11.1004 21.767 10.9716 21.0398 10.9716H19.4716V18.392Z",
    fill: "#272727"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.976197,
    y1: 15.0003,
    x2: 42.9762,
    y2: 14.0003,
    stroke: "#272727",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionDCrossOut);
export default __webpack_public_path__ + "static/media/OptionDCrossOut.66eec6fad837e03744ba3de55c25db61.svg";
export { ForwardRef as ReactComponent };